export enum Risk {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
}